import { render, staticRenderFns } from "./ManageUserModal.vue?vue&type=template&id=87f35cd8"
import script from "./ManageUserModal.vue?vue&type=script&lang=js"
export * from "./ManageUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports